import FilterTemplate from '../../html/components/filter.html'
import FilterToggleTemplate from '../../html/components/filter-toggle.html'
import FilterMenuTemplate from '../../html/components/filter-menu.html'
import FilterOptionTemplate from '../../html/components/filter-option.html'
import FilterFormTemplate from '../../html/components/filter-form.html'

import {inert} from '../shared/directives'
import Component from '../shared/component'
import Relation, {HasOne, MemberOf} from '../shared/mixins/relation'

import {Button} from './button'
import {Icon} from './icon'
import {Form} from './form'
import {Select, SelectToggle, SelectMenu, SelectOption} from './select'

const filterToggle = Relation()
const filterMenu = Relation()
const filterForm = Relation()

function copy (value) {
  return JSON.parse(JSON.stringify(value))
}

export const Filter = Component('v-filter', {
  model: {
    prop: 'value',
    event: 'change'
  },
  components: [
    Select,
    Button,
    Icon
  ],
  mixins: [
    HasOne(filterToggle, 'toggle'),
    HasOne(filterMenu, 'menu'),
    HasOne(filterForm, 'form')
  ],
  template: FilterTemplate,
  props: {
    value: {
      default: null
    },
    labelClear: {
      type: String
    }
  },
  data () {
    return {
      active: this.value
    }
  },
  computed: {
    variant () {
      if (this.menu) {
        return this.active !== null ? 'primary' : null
      }

      if (this.form) {
        return 'outline'
      }
    }
  },
  watch: {
    value () {
      this.active = this.value
    },

    active () {
      if (this.form) {
        this.form.active = copy(this.active)
      }

      setTimeout(() => {
        this.$emit('change', this.active)
      })
    },

    form () {
      this.form.active = copy(this.active)
      this.form.$on('change', this.change)
    }
  },
  methods: {
    change (value) {
      this.active = value
    },

    clear () {
      const {select} = this.$refs

      if (select) {
        select.clear()
      }
    }
  }
})

export const FilterToggle = Component('v-filter-toggle', {
  components: [
    SelectToggle,
    Button,
    Icon
  ],
  mixins: [
    MemberOf(filterToggle, 'filter')
  ],
  template: FilterToggleTemplate,
  data () {
    return {
      open: false
    }
  },
  computed: {
    variant () {
      const {filter} = this

      if (filter) {
        return filter.variant
      }
    },

    form () {
      const {filter} = this

      if (filter) {
        return filter.form
      }
    },

    target () {
      const {form} = this

      if (form) {
        return form.id
      }
    }
  },
  watch: {
    open () {
      this.$emit('toggle', this.open)
    }
  },
  methods: {
    toggle () {
      if (this.open) {
        this.hide()
      } else {
        this.show()
      }
    },

    show () {
      if (!this.open) {
        this.open = true
      }
    },

    hide () {
      if (this.open) {
        this.open = false
      }
    }
  }
})

export const FilterMenu = Component('v-filter-menu', {
  components: [
    SelectMenu
  ],
  mixins: [
    MemberOf(filterMenu, 'filter')
  ],
  template: FilterMenuTemplate,
  props: {
    labelSearch: {
      type: String,
      required: true
    }
  }
})

export const FilterOption = Component('v-filter-option', {
  components: [
    SelectOption
  ],
  template: FilterOptionTemplate,
  props: {
    value: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
})

export const FilterForm = Component('v-filter-form', {
  components: [
    Form,
    Button
  ],
  mixins: [
    MemberOf(filterForm, 'filter')
  ],
  directives: {
    inert
  },
  template: FilterFormTemplate,
  props: {
    labelCancel: {
      type: String,
      required: true
    },
    labelApply: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      active: {}
    }
  },
  computed: {
    open () {
      const {filter} = this

      if (!filter) {
        return
      }

      const {toggle} = filter

      if (toggle) {
        return toggle.open
      }
    }
  },
  methods: {
    hide () {
      const {filter} = this

      if (!filter) {
        return
      }

      const {toggle} = filter

      if (toggle) {
        toggle.hide()
      }
    },

    apply () {
      this.$emit('change', this.active)
      this.hide()
    },

    cancel () {
      const {filter} = this

      if (filter) {
        this.active = copy(filter.active)
      }

      this.hide()
    }
  }
})
